// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"0b5de9b1","238":"eda9e6e5","280":"043e2baf","584":"1fda5b7d","878":"ccb2fe5f","954":"d3863a62","957":"c5245589"}[chunkId] + ".css";
};